import { useSession } from '~hooks/useSession';
import { useGetChatsCountQuery } from '~services/api/bots/endpoints';
import { isSafeApp } from '~shared/utils/host';

export const useChatsCount = () => {
	const { userId } = useSession();
	const { data } = useGetChatsCountQuery(
		{ userId },
		{
			skip: !userId,
		}
	);

	const totalCount = data?.unreadMessagesCount || 0;
	const nsfwCount = data?.nsfwUnreadMessagesCount || 0;
	const sfwCount = totalCount - nsfwCount;

	return {
		unreadMessagesCount: isSafeApp ? sfwCount : totalCount,
	};
};
